import React from 'react';

import type { ReactNode } from 'react';

import { RTravelWithStars } from '@travel/icons/ui';
import { IconText, Tag } from '@travel/ui';

import styles from './membersOnlyTag.module.scss';

type Props = {
  text: ReactNode;
};

const MembersOnlyTag = (props: Props) => {
  return (
    <Tag type="filled" color="jet" className={styles.providerTag} data-testid="membersOnly-tag">
      <IconText icon={<RTravelWithStars size={14} />} text={props.text} spaceBetween={4} />
    </Tag>
  );
};

export default MembersOnlyTag;
